import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { SharingState, RootState } from '@/store/types';
import { GetterTree } from 'vuex';
import {
  InvitationValidationErrors,
  InvitationValidationSuccess,
} from './types';
import { Invite } from '@/models/invite';
import { Invitation } from '@/models/invitation';

const getters: GetterTree<SharingState, RootState> = {
  invite(state: SharingState): Invite {
    return state.invite;
  },

  selected(state: SharingState): Invitation {
    return state.selected;
  },

  validator(state: SharingState): Vue {
    return new Vue({
      mixins: [validationMixin],
      computed: {
        email: () => state.invite.email,
      },
      validations: {
        email: { required, email },
      },
    });
  },

  errors(state: SharingState, getters): InvitationValidationErrors {
    const errors: InvitationValidationErrors = {
      email: [],
    };
    /** Email */
    !getters.validator.$v.email.required &&
      errors.email.push('An email is required.');
    !getters.validator.$v.email.email &&
      errors.email.push('This is not a valid email.');

    return errors;
  },
  success(state: SharingState, getters): InvitationValidationSuccess {
    const formSuccess: InvitationValidationSuccess = {
      email: '',
    };

    /** Email */
    !getters.validator.$v.email.$invalid &&
      (formSuccess.email = 'This is a valid email.');

    return formSuccess;
  },

  valid(state: SharingState, getters) {
    return !getters.validator.$v.$invalid;
  },
};

export default getters;
